<template>
  <div class="creator-filter">
    <button :class="filterToggleClassObject" @click="toggleFilterList">{{ filterText }}</button>
    <div :class="filterListClassObject">
      <div :class="showAllClassObject" @click="showAll">Show All</div>
      <filter-button v-for="cat in categories" :key="cat" :filter="cat"></filter-button>
    </div>
  </div>
</template>
<script>
import FilterButton from './FilterButton.vue';

export default {
  data() {
    return {
      filterText: 'Filter +',
      categories: [],
      showAllClassObject: {
        'creator-filter__button': true,
        'is_active': this.$store.state.showAllCreators
      },
      filterListClassObject: {
        'creator-filter__list': true,
        'is_active': false
      },
      filterToggleClassObject: {
        'creator-filter__toggle': true,
        'is_filtered': false
      }
    }
  },
  methods: {
    showAll() {
      this.showAllClassObject.is_active = true;
      this.$store.commit('setShowAllCreators', true);
      this.$store.commit('setCategoryToDisplay', '');
    },
    toggleFilterList() {
      if (this.filterListClassObject.is_active === false) {
        this.filterText = 'Filter -';
        this.filterListClassObject.is_active = true;
      }
      else {
        this.filterListClassObject.is_active = false;
        this.filterText = 'Filter +';
      }
    }
  },
  mounted: function () {
    this.$store.state.creators.forEach(creator => {
      creator.categorySelect.forEach(cat => {
        if (!this.categories.includes(cat)) {
          this.categories.push(cat);
          this.$store.commit('addCategory', cat);
        }
      });
    });
  },
  watch: {
    '$store.state.showAllCreators': function() {
      if (this.$store.state.showAllCreators) {
        this.filterToggleClassObject.is_filtered = false;
        this.showAllClassObject.is_active = true;
      } else {
        this.filterToggleClassObject.is_filtered = true;
        this.showAllClassObject.is_active = false;
      }
    },
  },
  components: {
    FilterButton
  }
}
</script>


// WEBPACK FOOTER //
// FilterList.vue?3728eb0e